import * as $ from 'jquery/dist/jquery.min.js';
import 'bootstrap/dist/js/bootstrap.min.js';
window.$ = window.jQuery = $;
